import angular from 'angular';
var SearchResultsController = /** @class */ (function () {
    function SearchResultsController(Auth, $scope, $rootScope, NavbarService, CartService, SearchService, FilterService, ProductService, $compile, $window, $sce, $state, $stateParams, $anchorScroll, $location, profileData, CommonDataService, $timeout, BannerClickProcessor, productAlternatives, unleashFeatureService, seoMetaService) {
        'ngInject';
        // Alert Model for displaying alerts on the search results page
        this.alertState = {
            show: false,
            message: ''
        };
        this.errors = { pageErrorType: 'string' };
        this.itemQuantity = 1; // number inside addToCart buttons
        this.filterModel = null;
        this.loggedInAs = 'nonLoggedIn';
        this.pageModel = {
            totalItems: 0,
            currentPage: 1,
            pageSize: 24,
            totalPages: 1,
            pages: [1],
        };
        this.searchDisplayTerm = '';
        this.loadingSearchResults = false;
        this.seoMetaService = seoMetaService;
        this.cartService = CartService;
        this.Auth = Auth;
        this.searchService = SearchService;
        this.sortModel = SearchService.sortModel;
        this.filterService = FilterService;
        this.productService = ProductService;
        this.commonDataService = CommonDataService;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$location = $location;
        this.$window = $window;
        this.$timeout = $timeout;
        this.profileData = profileData;
        this.BannerClickProcessor = BannerClickProcessor;
        this.productAlternatives = productAlternatives;
        this.unleashFeatureService = unleashFeatureService;
    }
    SearchResultsController.prototype.$onInit = function () {
        var _this = this;
        if (this.$stateParams['q']) {
            this.seoMetaService.updateSeoMetaData(this, 'SearchWithQuality');
        }
        else {
            this.seoMetaService.updateSeoMetaData(this, 'SearchResultsController');
        }
        this.loadingSearchResults = true;
        var firstFilter;
        var firstFilterType;
        var searchTerm;
        if (this.$state.current.name === 'searchResults') {
            var paramKeyValue = this.filterService.getLandingSearchParamValue();
            firstFilterType = paramKeyValue[0];
            firstFilter = parseInt(paramKeyValue[1]);
            var searchFilter = this.$stateParams.searchFilter;
            this.searchDisplayTerm = searchFilter.substring(0, searchFilter.lastIndexOf('-')).replace(/-/g, ' ');
            this.searchService.clickedSearchTerm = this.searchDisplayTerm;
        }
        else { // state is 'advSearchResults'
            firstFilter = this.$stateParams['ff'];
            firstFilterType = this.$stateParams['fft'];
            searchTerm = this.$stateParams['term'];
            if (firstFilterType === 'term') {
                this.searchDisplayTerm = firstFilter;
                this.searchService.clickedSearchTerm = firstFilter;
            }
            else {
                this.searchDisplayTerm = searchTerm && searchTerm !== '*' ? searchTerm : this.searchService.clickedSearchTerm;
            }
        }
        if (!this.searchDisplayTerm || !this.searchService.clickedSearchTerm) {
            this.filterService.lookupSearchTerm(firstFilter, firstFilterType)
                .then(function (term) {
                _this.searchDisplayTerm = term;
                _this.searchService.clickedSearchTerm = term;
            });
        }
        this.getSearchFacets(firstFilter, firstFilterType);
        this.calculateSearchParametersForBanner();
        this.getSearchResults();
        this.setSortModel();
        if (this.profileData && this.profileData.status === 200) {
            this.commonDataService.setUserData(this.profileData.data.response);
            this.userData = this.commonDataService.userData;
        }
        this.unleashFeatureService
            .isEnabledObserveViaName('ares-single-registration')
            .subscribe(function (isEnabled) {
            _this.$rootScope.singleRegistrationFlag = isEnabled;
        });
    };
    SearchResultsController.prototype.getSearchFacets = function (firstFilter, firstFilterType) {
        var _this = this;
        this.filterService.getSearchFacets(firstFilter, firstFilterType)
            .then(function (data) {
            _this.filterModel = data;
        });
    };
    SearchResultsController.prototype.onBannerClicked = function (data) {
        this.BannerClickProcessor.process(data);
    };
    SearchResultsController.prototype.calculateSearchParametersForBanner = function () {
        var searchData = this.searchService.mapSearchParameter(this.$stateParams);
        this.searchData = {
            brandIds: new Set((searchData.brands || []).map(function (str) { return parseInt(str); })),
            conditionIds: new Set((searchData.conditions || []).map(function (str) { return parseInt(str); })),
            categoryIds: new Set((searchData.categories || []).map(function (str) { return parseInt(str); })),
            subCategoryIds: new Set((searchData.subcategories || []).map(function (str) { return parseInt(str); })),
            attributeIds: new Set((searchData.attributes || []).map(function (str) { return parseInt(str); })),
            searchTerms: searchData.searchTerm
        };
    };
    SearchResultsController.prototype.getSearchResults = function () {
        var _this = this;
        this.searchService.searchRequest(this.$stateParams)
            .then(function (data) {
            if (data['pageNumber'] && data['totalResultCount']) {
                _this.setPageModel(data['pageNumber'], data['totalResultCount']);
            }
            _this.products = data.currentPage;
            _this.calculateHasAlternatives();
            if (_this.$stateParams['fft'] === 'term') {
                _this.searchService.getRecentSearches();
            }
        })
            .catch(function () {
            _this.alertState.message = "Oops! There was a problem getting you your products. Please click\n          <a href=\"" + _this.$location.absUrl() + "\" target=\"_self\">here</a> to refresh the page and try again.";
            _this.alertState.show = true;
        })
            .finally(function () {
            _this.loadingSearchResults = false;
        });
    };
    SearchResultsController.prototype.calculateHasAlternatives = function () {
        var _this = this;
        if (!this.isLoggedIn())
            return;
        if ((this.products || []).length == 0)
            return;
        this.products.forEach(function (product) { product.hasAlternatives = false; });
        this.productAlternatives
            .getProductIdsWithAlternativesAsPromise(this.products
            .filter(function (product) { return _this.doesProductHaveDisabledButton(product); })
            .map(function (product) { return product.productId; }))
            .then(function (productIdSet) {
            _this.products.forEach(function (product) {
                product.hasAlternatives = productIdSet.has(product.productId);
            });
        }, function () { });
    };
    SearchResultsController.prototype.doesProductHaveDisabledButton = function (product) {
        var disabledItems = (product.items || []).filter(function (item) {
            var defaultInventories = (item.inventory || []).filter(function (inventory) { return inventory.isDefault; });
            defaultInventories.push({ stock: 0, vendorBackOrder: false });
            var defaultInventory = defaultInventories[0];
            var restricted = !!item.isRestricted;
            var discontinued = !!item.isDiscontinued;
            var inStock = (defaultInventory.stock || 0) > 0;
            var isVbo = !!defaultInventory.vendorBackOrder;
            return restricted || (!inStock && (discontinued || isVbo));
        });
        return disabledItems.length > 0;
    };
    // Auth
    SearchResultsController.prototype.isLoggedIn = function () {
        var loggedInUser = this.Auth.getLoggedInUser();
        return !!loggedInUser;
    };
    SearchResultsController.prototype.setPageModel = function (pageNumber, numberCount) {
        this.pageModel.totalItems = parseInt(numberCount) || 1;
        this.pageModel.currentPage = parseInt(pageNumber) || 1;
        this.pageModel.totalPages = Math.ceil(this.pageModel.totalItems / this.pageModel.pageSize);
        this.pageModel.pages = [];
        for (var i = 1; i <= this.pageModel.totalPages; i++) {
            this.pageModel.pages.push(i);
        }
    };
    SearchResultsController.prototype.pageChanged = function () {
        var state = Object.assign({}, this.$stateParams);
        this.filterService.checkForLandingPageTransition(state);
        state['page'] = this.pageModel.currentPage + '';
        this.$state.go('advSearchResults', state);
    };
    SearchResultsController.prototype.setSortModel = function () {
        var _this = this;
        var isAssending = this.$stateParams['order'] === 'true' ? 'true' : 'false';
        var sortOrder = this.$stateParams['sort'] ? this.$stateParams['sort'] : '0';
        this.sortModel.forEach(function (model) {
            if (model.assending === isAssending && model.value === sortOrder) {
                _this.sortSelected = model;
            }
        });
        // hide 'sort by price' if user is not logged in
        if (!this.isLoggedIn()) {
            this.sortModel = this.sortModel.filter(function (item) {
                return item.value !== 6;
            });
        }
    };
    SearchResultsController.prototype.addToCart = function (itemId) {
        this.cartService.addItem(itemId);
    };
    SearchResultsController.prototype.sortSelectAction = function (item) {
        var state = angular.copy(this.$stateParams);
        this.filterService.checkForLandingPageTransition(state);
        state['sort'] = item.value ? item.value : '0';
        state['order'] = item.assending;
        this.$state.go('advSearchResults', state);
    };
    SearchResultsController.prototype.close = function (e) {
        var lights = document.getElementsByClassName('quantityDropdownToggle');
        while (lights.length) {
            lights[0].className = lights[0].className.replace(/\bdropdown-active\b/g, '');
        }
    };
    // Product Card Item Quantity Control
    SearchResultsController.prototype.decrement = function (id) {
        this.currentIndex = null;
        var index = this.items.findIndex(function (item) { return item.itemId == id; });
        var quantity = parseInt(this.items[index].quantity);
        if (quantity - 1 === 0) {
            this.setCurrentIndex(id);
        }
        else {
            this.items[index].quantity = quantity - 1;
        }
        this.items[index].total = this.items[index].quantity * this.items[index].pricePerEach;
        this.cartService.itemQuantity(id, quantity);
    };
    SearchResultsController.prototype.increment = function (id) {
        this.currentIndex = null;
        var index = this.items.findIndex(function (item) { return item.itemId == id; });
        var quantity = parseInt(this.items[index].quantity) + 1;
        this.items[index].quantity = quantity;
        this.items[index].total = this.items[index].quantity * this.items[index].pricePerEach;
        this.cartService.itemQuantity(id, quantity);
    };
    SearchResultsController.prototype.updateQuantity = function (id, quantity) {
        if (quantity === 0) {
            this.confirmRemove(id);
        }
        else if (quantity !== undefined) {
            var index = this.items.findIndex(function (item) { return item.itemId == id; });
            this.items[index].quantity = quantity;
            this.items[index].total = this.items[index].quantity * this.items[index].pricePerEach;
        }
    };
    SearchResultsController.prototype.closeAlertMessage = function () {
        this.alertState.show = false;
    };
    SearchResultsController.prototype.getValue = function (array, id) {
        var returnValue = '';
        array.forEach(function (arr) {
            if (arr.id.toString() === id) {
                returnValue = arr.value;
            }
        });
        return returnValue;
    };
    SearchResultsController.prototype.scrollSearchToView = function (response) {
        var _this = this;
        if (response) {
            this.$timeout(function () {
                _this.$window.scroll(0, parseInt(sessionStorage.getItem('prevOffset')));
            }, 0, false);
        }
    };
    return SearchResultsController;
}());
export default SearchResultsController;
//# sourceMappingURL=search-results.controller.js.map